// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"page_mainDiv__4APJ6","labelsDiv":"page_labelsDiv__CyJzs","mainBox":"page_mainBox__1nUHO","insideBox":"page_insideBox__ZYnU_"};